import React, { useState } from "react";
import { FaCog } from "react-icons/fa";
import "./AdminDashboard.css";

export default function ActionMenu({ onUserManagement, onPricing, onSettings, onNetSuiteItems }) {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    { label: "User Management", onClick: () => { onUserManagement(); setIsOpen(false); } },
    { label: "Pricing Rules",   onClick: () => { onPricing();         setIsOpen(false); } },
    { label: "NetSuite Items",  onClick: () => { onNetSuiteItems?.(); setIsOpen(false); } },
    { label: "Settings",        onClick: () => { onSettings();        setIsOpen(false); } },
  ];

  return (
    <div className="action-menu-navbar">
      <button
        className={`action-menu-trigger ${isOpen ? "active" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
        title="More options"
      >
        <FaCog className="action-menu-icon" />
        <span>More</span>
      </button>

      {isOpen && (
        <div className="action-menu-inline">
          {menuItems.map((item, idx) => (
            <button key={idx} className="action-menu-item" onClick={item.onClick}>
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}